export { FEATURE_ACTION } from "@ovou-inc/ovou-ui";

export enum FEATURES {
  MANAGE_USERS = "manage_users",
  MANAGE_PROFILES = "manage_profiles",
  CONTACTS = "contacts",
  ANALYTICS = "analytics",
  GROUPS = "groups",
  SETTINGS = "settings",
  COMPANY_PROFILE = "company_profile",
  MANAGE_DEVICES = "manage_devices",
  TUTORIALS = "tutorials",
  INTEGRATIONS = "integrations",
  MANAGE_SUBSCRIPTION = "manage_subscription",
  INVITE_USERS_MODAL = "invite_users_modal",
  MANAGE_USERS_DELETE_USER = "manage_users_delete_user",
  MANAGE_USERS_RESEND_EMAIL = "manage_users_resend_email",
  MANAGE_USERS_CHANGE_EMAIL = "manage_users_change_email",
  UPGRADE_NOW = "upgrade_now",
  ORDER_MORE_CARDS = "order_more_cards",
  MANAGE_USERS_CHANGE_ROLE = "manage_users_change_role",
  MANAGE_USERS_SETUP_PROFILE = "manage_users_setup_profile",
  MANAGE_USERS_EDIT_PROFILE = "manage_users_edit_profile",
  SHOP = "shop",
  CONTACT_ENRICHMENT = "team-contact-enrichment",
  // Defined in ovou-ui's FEATURES too (source of truth for permission lookups
  // via useGetPermissions in useTeamPermission). Re-listed here so consumers
  // that only pass the string value (menu config, tracking, PageSetup) keep
  // the uniform `FEATURES.X` access pattern.
  PROFILE_TEMPLATES = "profile_templates",
  CREATE_TEMPLATE = "create_template",
  // Template Content authoring gates (V1.5). Values are the bare permission
  // features; useCheckPermission builds the `edit_files` / `edit_photo_gallery`
  // lookup keys, which the permission set already carries. (ovou-ui's canonical
  // FEATURES doesn't list these yet — mirror them there in a follow-up.)
  FILES = "files",
  PHOTO_GALLERY = "photo_gallery",
  // NOTE: the plan-gated template-cluster keys (customize_instant_followup_email,
  // customize_lead_capture_form_*, custom_call_to_action, instant_lead_capture)
  // are intentionally NOT redefined here — they live in ovou-ui's FEATURES (the
  // canonical source) and are passed straight from there to useCheckPermission,
  // which accepts both this local enum and ovou-ui's.
}
